import * as actions from "appRedux/actions/chargeSchedule/ChargeInhouseActionType"
import { ChargeScheduleProcess, chargeScheduleType, RateBreakdownGroup } from "./chargeType"

type chargeInhouseDetailDataSource = {
    full_name?: string | null,
    status?: string | null,
    extra_adult?: number,
    extra_child?: number,
    extra_infant?: number
}

export interface chargeInhouseState {
    loader: boolean,
    keyword:string,
    dataSource: chargeScheduleType[],
    breakdownDataSource: RateBreakdownGroup[],
    breakdownLoader: boolean,
    detailDataSource?: chargeInhouseDetailDataSource,
    filterChargeSchedule: any,
    process: ChargeScheduleProcess
}

const initialState: chargeInhouseState = {
    loader: false,
    keyword:'',
    dataSource: [],
    breakdownDataSource: [],
    breakdownLoader: false,
    detailDataSource:undefined,
    filterChargeSchedule: [],
    process:{ status:false,action:"",message:""}
}

export default (state: chargeInhouseState = initialState,action: actions.ChargeInhouseAction): chargeInhouseState =>{
    switch (action.type) {
    case actions.CHARGE_INHOUSE_REQUEST:{
        return {
            ...state,
            loader:true,
            dataSource:[],
            process: {status:false,action:"",message:""}
        }
    }
    case actions.CHARGE_INHOUSE_DETAIL_REQUEST:{
        return {
            ...state,
            detailDataSource:undefined,
            process: {status:false,action:"",message:""}
        }
    }
    case actions.CHARGE_INHOUSE_UPDATE:{
        return {
            ...state,
            process: {status:false,action:"",message:""}
        }
    }
    case actions.CHARGE_INHOUSE_PROCESS_SUCCESS:{
        return{
            ...state,
            process:action.payload
        }
    }
    case actions.CHARGE_INHOUSE_DATASOURCE_SUCCESS:{
        return{
            ...state,
            loader:false,
            dataSource: action.payload
        }
    }
    case actions.CHARGE_INHOUSE_BREAKDOWN_REQUEST:{
        return {
            ...state,
            breakdownLoader:true,
            breakdownDataSource:[],
            process: {status:false,action:"",message:""}
        }
    }
    case actions.CHARGE_INHOUSE_BREAKDOWN_SUCCESS:{
        return{
            ...state,
            breakdownLoader:false,
            breakdownDataSource:action.payload
        }
    }
    case actions.CHARGE_INHOUSE_DETAIL_DATASOURCE_SUCCESS:{
        return{
            ...state,
            detailDataSource: action.payload
        }
    }
    case actions.CHARGE_INHOUSE_SET_FILTER:{
        return{
            ...state,
            filterChargeSchedule:action.payload
        }
    }
    case actions.CHARGE_INHOUSE_PROCESS_RESET:{
        return{
            ...state,
            process:{ status:false,action:"",message:""}
        }
    }
    default:
        return state;
    }
}
